<template>
  <div
    class="carousel"
    @mouseenter="pauseAnimation"
    @mouseleave="resumeAnimation"
  >
    <div class="slides" :style="slideStyle">
      <div v-for="(image, index) in imagesWithClone" :key="index" class="slide">
        <img :src="image" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoverPauseCarousel',
  data () {
    return {
      images: [
        require('@/assets/公司荣誉/WechatIMG25.jpeg'),
        require('@/assets/公司荣誉/WechatIMG24.jpeg'),
        require('@/assets/公司荣誉/WechatIMG26.jpeg'),
        require('@/assets/公司荣誉/WechatIMG35.jpeg'),
        require('@/assets/公司荣誉/WechatIMG36.jpeg'),
        require('@/assets/公司荣誉/WechatIMG37.jpeg'),
        require('@/assets/公司荣誉/WechatIMG38.jpeg')
      ],
      slideWidth: 250, // 每张图片的宽度（包含间隔）
      visibleSlides: 5, // 一次显示的图片数量
      isPaused: false // 是否暂停动画
    }
  },
  computed: {
    // 在图片列表末尾添加前五张图片的副本
    imagesWithClone () {
      return [...this.images, ...this.images.slice(0, this.visibleSlides)]
    },
    // 动态绑定 slides 的样式
    slideStyle () {
      return {
        animationPlayState: this.isPaused ? 'paused' : 'running'
      }
    }
  },
  methods: {
    // 暂停动画
    pauseAnimation () {
      this.isPaused = true
    },
    // 恢复动画
    resumeAnimation () {
      this.isPaused = false
    }
  }
}
</script>

<style scoped>
.carousel {
  width: 1250px; /* 视窗宽度 = 每张图片宽度 * 可见图片数量 */
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  height: 400px; /* 容器高度 */
}

.slides {
  display: flex;
  height: 100%;
  animation: slideLeft linear infinite;
  animation-duration: 50s; /* 动画持续时间 */
}

.slide {
  width: 200px; /* 每张图片的宽度 */
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 50px; /* 容器之间的间隔 */
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片完整显示 */
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-1250px); /* 移动距离 = 每张图片宽度 * 图片数量 */
  }
}
</style>
